import { Flex, Typography, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { formatCurrency } from '../../helpers/helpers';

const InvestmentBreakdownRow = ({ label, tooltip, value }) => (
    <Flex align="center" justify="space-between">
        <Flex gap="small">
            <Typography style={{ color: '#40566D', fontSize: 12 }}>
                {label}
            </Typography>
            <Tooltip placement="right" title={tooltip}>
                <InfoCircleOutlined
                    rotate={180}
                    style={{ color: '#40566D', fontSize: 12 }}
                />
            </Tooltip>
        </Flex>
        <Typography style={{ fontSize: 14, fontWeight: 600 }}>
            {formatCurrency(value)}
        </Typography>
    </Flex>
);

export default InvestmentBreakdownRow;
